var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseActions',{attrs:{"action-list":_vm.actions},on:{"action":function($event){return _vm.receiveSelectedConstructsAction($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }